<div class="use-case-label">CLICK A BUTTON TO START</div>
<div class="run-section">
  <div class="flex-container">

    <div class="flex-item item" id="startbutton" style="text-align: center; padding: 0;cursor: pointer" (click)="capture()" >
      <button class="capture-btn btn-start-capture" style="margin-top: 10px;">
        <img [src]="splash_png" alt="Capture Icon" height="60" width="60" style="padding: 10px !important;" />
        <p class="capture-text">FACE CAPTURE</p>
      </button>
    </div>

    <div *ngIf="!faceOnly" class="flex-item item" id="vsbutton" style="text-align: center; padding: 0;cursor: pointer" (click)="runVideoSelfie()" >
      <button class="capture-btn btn-start-capture vs-btn" style="margin-top: 10px;">
        <img [src]="splash_png" alt="Video Selfie Icon" height="60" width="60" style="padding: 10px !important;" />
        <p class="capture-text">VIDEO SELFIE</p>
      </button>
    </div>

  </div>
</div>
